<div class="form" [ngClass]="{'is-overlay': isLoadingCities$ | async}" [formGroup]="form">
  @if (isLoadingCities$ | async) {
    <div class="form__overlay">
      <mat-spinner color="accent"></mat-spinner>
    </div>
  }

  @if (cityStreets$ | async; as cityStreets) {
    <div class="form__col _md">
      <mat-form-field appearance="outline">
        <mat-label i18n="@@Zone">Zone</mat-label>
        <mat-select formControlName="street">
          <mat-option>
            <ngx-mat-select-search
              #streetFilter
              [clearSearchInput]="false"
              placeholderLabel="Search"
              i18n-placeholderLabel="@@Search"
              noEntriesFoundLabel="No matches found"
              i18n-noEntriesFoundLabel="@@NoMatchesFound"
            ></ngx-mat-select-search>
          </mat-option>
          <cdk-virtual-scroll-viewport itemSize="42" minBufferPx="200" maxBufferPx="400" [style.height.px]="5*42" class="example-viewport">
            <mat-option
              (onSelectionChange)="onChangeStreet($event, cityStreet)"
              [value]="cityStreet.street.name"
              *cdkVirtualFor="let cityStreet of cityStreets | filter:'street.name':streetFilter.value | sortString: 'street.name'"
              >
              {{ cityStreet.street.name }} ({{ cityStreet.city.name }})
            </mat-option>
          </cdk-virtual-scroll-viewport>
        </mat-select>
        <mat-error i18n="@@ErrorMessageRequired">Required</mat-error>
      </mat-form-field>
    </div>
    <div class="form__col _md">
      <app-ez-input>
        <input
          appEzInput
          type="text"
          formControlName="house"
          name="house"
          maxlength="100"
          data-testid="house"
        >
        <ng-container ezLabel i18n="@@AddressDetails">Address details</ng-container>
        @if (form.controls!.house!.hasError('required') && (form.controls!.house!.dirty || form.controls!.house!.touched)) {
          <ng-container ezError i18n="@@ErrorMessageRequired">Required</ng-container>
        }
      </app-ez-input>
    </div>
    <div class="form__col _md">
      <app-ez-input>
        <input
          appEzInput
          type="text"
          formControlName="flat"
          name="flat"
          maxlength="15"
          data-testid="flat"
        >
        <ng-container ezLabel i18n="@@Apartment">Apartment</ng-container>
        @if (form.controls!.flat!.hasError('required') && (form.controls!.flat!.dirty || form.controls!.flat!.touched)) {
          <ng-container ezError i18n="@@ErrorMessageRequired">Required</ng-container>
        }
      </app-ez-input>
    </div>
  } @else {
    @if ((isLoadingCities$ | async) === false) {
      <span class="button-panel-message small button-panel-message_error" i18n="@@AddressCitiesNotLoad">Failed to load list of cities. Delivery is not available. Select pickup.</span>
    }
  }
</div>

